import { TITLE_SCREEN } from '../constants/routes';
import {
    GO_BACK,
    GO_TO_SCREEN,
    GO_TO_SCREEN_AND_RESET_HISTORY,
    SET_HISTORY_SCREEN_STATE,
} from '../constants/actions';
import { getNewHistoryAndBackRoute } from '../helpers/router';

const defaultRouter = {
    currentRoute: TITLE_SCREEN,
    history: [TITLE_SCREEN],
    historyScreenState: {
        screen: null,
        state: {},
    },
};

export const router = (state = defaultRouter, action) => {
    switch (action.type) {
        case GO_TO_SCREEN:
            return {
                ...state,
                currentRoute: action.route,
                history: [...state.history, action.route],
            };
        case GO_TO_SCREEN_AND_RESET_HISTORY:
            return {
                ...state,
                currentRoute: action.route,
                history: [action.route],
                historyScreenState: {
                    screen: null,
                    state: {},
                },
            };
        case SET_HISTORY_SCREEN_STATE:
            return {
                ...state,
                historyScreenState: {
                    screen: action.screen,
                    state: action.state,
                },
            };
        case GO_BACK:
            return {
                ...state,
                ...getNewHistoryAndBackRoute(state.history),
            };
        default:
            return state;
    }
};
